import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";


import ModalAccount from "../accounts/modals/modal-account";
// import ModalFarmOrSubEnt from "./modals/modal-farm";
import ModalUser from "./modals/modal-user";
import ModalUserRemove from "./modals/modal-user-remove";
import ModalRebate from "./modals/modal-rebate";
import { CustomerInfoBlock, FarmsBlock, RebatesBlock, UsersBlock } from "./blocks";
import ModalFarmOrSubEnt from "../farm/modals/modal-farm-or-sub-ent";
import { CustomButton } from "../../components";
import ModalAccountRemove from "../accounts/modals/modal-account-remove";
import useaccount from "../../hooks/use-account";
import { LoginContext } from "../../context/login-context";
import ModalValleyRep from "./modals/modal-valley-rep";
import useUsers from "../../hooks/use-users";


const AccountDetails = (props) => {
  const {
    accountType
} = props

// console.log("accountType", accountType)
  const navigate = useNavigate()
  const { valleyUsers, valleyRefetchUsers } = useUsers()
  const { state: userData } = useContext(LoginContext);
  const { accountName: accountNameParam } = useParams();
  //todo this is broken if user has multiple strategic accounts (assuming a strat acct user has only one strat acct. If user only has one account (which if you are a strat acct user or a Sub Account user, going to /account will route you to your only account without requiring a query param)
  // const [accountName, setAccountName] = useState();
  
  const defaultAcctName = accountType === 'STRATEGIC_ACCOUNT' ? userData?.associatedAcctIds?.temp_strat_acct_name :  userData?.associatedAcctIds?.temp_sub_entity_acct_name


  const [accountName, setAccountName] = useState  (accountNameParam || defaultAcctName);
  const { account, refetchaccount } = useaccount({ accountName, accountType });

  const [showShowValleyRepModal, setShowShowValleyRepModal] = useState(false);
	const [showCompanyModal, setShowCompanyModal] = useState(false);
  const [showAccountRemoveModal, setShowAccountRemoveModal] = useState(false);

	const [showFarmModal, setShowFarmModal] = useState(false);
	// const [showFarmRemoveModal, setShowFarmRemoveModal] = useState(false);
	const [showRebateModal, setShowRebateModal] = useState(false);
	// const [showRebateRemoveModal, setShowRebateRemoveModal] = useState(false);
	const [showUserModal, setShowUserModal] = useState(false);

	const [activeUser, setActiveUser] = useState(null);


  // const canAddSubEntity =  account?.parent_account &&  account?.parent_account?.parent_account ? (account?.parent_account?.account_type != 'SUB_ENTITY' && account?.account_type != 'SUB_ENTITY') : true

  //only allow one sub entity for now
    const canAddSubEntity =  account?.account_type == 'STRATEGIC_ACCOUNT'

  useEffect(() => {
    refetchaccount()
  }, [accountName])


  useEffect(() => {
    if(!accountNameParam){return}
    setAccountName(accountNameParam || defaultAcctName)
  }, [accountNameParam])

  // useEffect(() => {
  //   console.log(account)
  // }, [account])


  
  const handleEditCompanyDetails = (id) => {
		setShowCompanyModal(true);
	};

  const handleRemoveAccount = (id) => {
    setShowAccountRemoveModal(true);
  };
  
  const accountRemoveModalClose = () => {
    setShowAccountRemoveModal(false);
  };

	const handleAddFarm = (id) => {
		setShowFarmModal(true);
	};

	// const handleRemoveFarm = (id) => {
	// 	setShowFarmRemoveModal(true);
	// };

	const handleAddEditUser = (user) => {
    setShowUserModal(true);
    setActiveUser(user);
	};

  const handleAddEditValleyRep = (user) => {
    // console.log(user)
    setShowShowValleyRepModal(true);
    setActiveUser(user);
	};

  const valleyRepModalClose = () => {
    setShowShowValleyRepModal(false);
    setActiveUser(null);
    refetchaccount()
  }

  const handleAddRebate = (id) => {
    setShowRebateModal(true);
  }

	const companyModalClose = () => {
    refetchaccount()
		setShowCompanyModal(false);
	};

	const farmModalClose = () => {
    refetchaccount()
		setShowFarmModal(false);
    // setShowFarmRemoveModal(false);
	};

  const userModalClose = () => {
    refetchaccount()
    setShowUserModal(false);
  }

  const rebateModalClose = () => {
    refetchaccount()
    setShowRebateModal(false);
    // setShowRebateRemoveModal(false);
  }

  const btnRemove = (
    <CustomButton
      label={`Remove ${account?.account_type == 'SUB_ENTITY' ? "Sub Account" : "Account"}`}
      onClick={handleRemoveAccount}
      color="danger"
      outlined
    />
  );

  const info = (
    <CustomerInfoBlock
      account={account}//{filteredAccounts[0] || null}
      onClick={handleEditCompanyDetails}
      btnRemove={btnRemove}
    />
  );

	const tableFarms = (
    <FarmsBlock
    canAddSubEntity={canAddSubEntity}
      farms={account?.children_accounts}
      onAddFarm={handleAddFarm}
      // onRemoveFarm={handleRemoveFarm}
      onEditFarm={handleAddFarm}
    />
  );

  const tableRebatesIssued = (

    <RebatesBlock
      rebates={account?.strategic_account_rebate}
      onAddRebate={handleAddRebate}
    />
	);

	const tableUsers = (

    <UsersBlock
      canCrud={userData?.isValmontUser || (userData?.associatedAcctIds?.stratAcctIds?.includes(account?.id)) }
      userConfigType={"Account"}
      users={account?.users?.filter(u=> u.user_role != "VALMONT_REP" &&  u.user_role != "VALMONT_FINANCE") || []}
      onAddEditUser={handleAddEditUser}
      // onRemoveUser={handleRemoveUser}
    />
  );


// console.log(filteredReps)
  const valmontReps = (
    <UsersBlock
    canCrud={userData?.isValmontUser }
      userConfigType={"Valley Rep"}
      users={
        account?.users?.filter(u => u.user_role === "VALMONT_REP" || u.user_role === "VALMONT_FINANCE")
        // filteredReps
        // ?.filter(u=> ) 
        || []}
      onAddEditUser={handleAddEditValleyRep}
      // onRemoveUser={handleRemoveUser}
    />
  );
  // console.log('account', account)
  const modals = (
		<>
			{showCompanyModal && (
        <ModalAccount
          open={showCompanyModal}
          onClose={companyModalClose}
          account={account}
        />
			)}

      {showAccountRemoveModal && (
        <ModalAccountRemove
          open={showAccountRemoveModal}
          onClose={accountRemoveModalClose}
          account={account}
        />
      )}

			{showFarmModal && (
				<ModalFarmOrSubEnt //from strat account page, this is either add farm or add Sub Account
					open={showFarmModal}
					onClose={farmModalClose}
          parent_account_id={account?.id}
          // account={account}
          // parent_account={account?.parent_account}
          canAddSubEntity={canAddSubEntity}
				/>
			)}


      {showRebateModal && (
        <ModalRebate
          open={showRebateModal}
          onClose={rebateModalClose}
          activeRebate={account.strategic_account_rebate?.find(reb=> reb.deleted_at == null)}
          account={account}
        />
      )}

      {showUserModal && (
        <ModalUser
          userConfigType={"Account"}
          open={showUserModal}
          onClose={userModalClose}
          user={activeUser||{user_role: "STRATEGIC_ACCOUNT"}}
          account= {account}
        />
      )}

      {showShowValleyRepModal && (
        <ModalValleyRep
          open={showShowValleyRepModal}
          onClose={valleyRepModalClose}
          selectedUser={activeUser}
          account={account}
          valleyUsers={valleyUsers}
          valleyRefetchUsers={valleyRefetchUsers}
        />
      )
      }
		</>
	);

	return (
		<>
			{info}
			{tableFarms}
			{accountType === "STRATEGIC_ACCOUNT" && tableRebatesIssued}
			{tableUsers}
      {valmontReps}
			{modals}
		</>
	);
};

export default AccountDetails;
